/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Search from 'apollo-react-icons/Search';
import classNames from 'classnames';
import React, { useState } from 'react';

import RepositoryZoomDialog from './RepositoryZoomDialog';
import { ZOOM_STYLES } from '../../../constants/CommonStylesConstants';
import { useFormSelector } from '../../../custom-hooks';
import { getUITA } from '../../../utils/commonUtils';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import { getPropByModel } from '../../selectors/form-manager.selectors';
import { getDynamicParamCollectionSelector } from '../../selectors/runtime.selectors';

const useStyles = makeStyles(ZOOM_STYLES);

function SSRuntimeRepositoryZoom({
  index,
  isEditor,
  uniqueIdentifier,
  actions,
  parent,
  id,
  isOnline,
}) {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);
  const entityName = useFormSelector(getPropByModel, {
    id: parent,
    prop: FORM_MODEL_ATTRIBUTES.ENTITY_NAME,
  });
  const dynamicParamCollection = useFormSelector(getDynamicParamCollectionSelector, {
    index,
    entityName,
    id,
  });

  const handleSelect = ({ selectedPath = [] }) => {
    const changesToApply = selectedPath.map((path, i) => ({
      value: path,
      entityName,
      fieldName: i === 0 ? 'REG_BODY_NAME' : `REG_BODY_LEVEL_${i}`,
      index,
    }));

    actions.bulkUpdateControlValues(changesToApply);
  };

  return (
    <>
      <span
        className={classNames(classes.root, isEditor ? classes.zoomEditMode : '')}
        onClick={() => !isEditor && isOnline && setDialogOpen(true)}
        ui-ta={getUITA('FormCtrl', 'SSRepositoryZoom', uniqueIdentifier)}
        data-ss-id={id}
      >
        <div>
          <Search className={classes.searchIcon} color={isOnline ? 'primary' : 'disabled'} />
        </div>
      </span>
      <RepositoryZoomDialog
        open={dialogOpen}
        onSelect={handleSelect}
        onClose={() => setDialogOpen(false)}
        dynamicParamCollection={dynamicParamCollection}
      />
    </>
  );
}

export default SSRuntimeRepositoryZoom;
